import { apiClient } from "./apiClient";

/**
 * Request a voluntary freeze of the current user's account.
 * Sets status to FROZEN_BY_USER. The freeze is automatically lifted on the next login.
 * While frozen, the user cannot receive messages from other users.
 */
export const requestAccountFreeze = (): Promise<void> =>
  apiClient.post<void>("/api/profile/me/freeze", undefined);

/**
 * Manually unfreeze the current user's account from the settings page.
 * This is an alternative to the automatic unfreeze that occurs on login.
 */
export const cancelAccountFreeze = (): Promise<void> =>
  apiClient.delete<void>("/api/profile/me/freeze");